import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { fmtDate } from '../../../../utils/fmt';

const LeadHistoryListDetails = () => {
  const { leadId } = useParams();
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const params = leadId ? { lead: leadId } : {};
        const response = await axios.get(`${API_DOMAIN}lead/lead-history/`, { headers, params });
        const data = response.data?.data ?? response.data;
        setHistory(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('Error fetching lead history:', error);
      }
    };
    fetchHistory();
  }, [leadId]);

  const columns = [
    { label: 'Action', value: 'action' },
    { label: 'User', value: (item) => item.user_name || 'Unknown User' },
    { label: 'Date', value: (item) => fmtDate(item.date) },
    { label: 'Details', value: 'details' },
  ];

  return (
    <div>
      <ListTemplate columns={columns} data={history} title="Lead History" />
    </div>
  );
};

export default LeadHistoryListDetails;
